import React, { useRef } from 'react';
import { FiPlay } from 'react-icons/fi';
import { podcastsAPI } from '../services/api';
import './PodcastVideoThumbnail.css';

interface PodcastVideoThumbnailProps {
  podcastId: number;
  alt: string;
  className?: string;
  /** When false, shows a static placeholder (e.g. locked content). */
  canLoad?: boolean;
}

const PodcastVideoThumbnail: React.FC<PodcastVideoThumbnailProps> = ({
  podcastId,
  alt,
  className = '',
  canLoad = true,
}) => {
  const seekedRef = useRef(false);

  if (!canLoad) {
    return (
      <div className={`podcast-video-thumbnail-placeholder ${className}`.trim()}>
        {React.createElement(FiPlay as React.ComponentType<{ size?: number }>, { size: 40 })}
      </div>
    );
  }

  return (
    <video
      className={`podcast-video-thumbnail ${className}`.trim()}
      src={podcastsAPI.getStreamURL(podcastId)}
      preload="metadata"
      muted
      playsInline
      aria-label={alt}
      onLoadedMetadata={(e) => {
        if (seekedRef.current) return;
        const video = e.currentTarget;
        const targetTime =
          video.duration && Number.isFinite(video.duration)
            ? Math.min(0.5, video.duration * 0.02)
            : 0.1;
        seekedRef.current = true;
        video.currentTime = targetTime;
      }}
    />
  );
};

export default PodcastVideoThumbnail;
